import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';

import MatchDetailsEdit from '../../../client/components/MatchDetailsEdit';
import VenueDetailsEdit from '../../../client/components/VenueDetailsEdit';
import VenueDateEdit from '../../../client/components/VenueDateEdit';
import MatchScoreEdit from '../../components/MatchScoreEdit'

const SELECTOR_PAGE = '.lta-match-result';

// Match Score
const SELECTOR_MATCH_SCORE_TRIGGER_BUTTON = '.js-trigger-match-score-edit';
const SELECTOR_MATCH_SCORE_EDIT_MODAL = '#match-score-edit-modal';
const SELECTOR_MATCH_SCORE_EDIT_MODAL_DIV = '.lta-match-score-edit';
const SELECTOR_MATCH_WINNER_NAME = '.match-winner-player1-name';
const SELECTOR_MATCH_WINNER_PARTNER_NAME = '.match-winner-player2-name';
const SELECTOR_PLAYER1_NAME = '.match-player1-name';
const SELECTOR_PLAYER1_PARTNER_NAME = '.match-player1-partner-name';
const SELECTOR_PLAYER2_NAME = '.match-player2-name';
const SELECTOR_PLAYER2_PARTNER_NAME = '.match-player2-partner-name';
const SELECTOR_PLAYER1_SET1_SCORE = '.player1-set1-score'; 
const SELECTOR_PLAYER1_SET2_SCORE = '.player1-set2-score';
const SELECTOR_PLAYER1_SET3_SCORE = '.player1-set3-score';
const SELECTOR_PLAYER2_SET1_SCORE = '.player2-set1-score';
const SELECTOR_PLAYER2_SET2_SCORE = '.player2-set2-score';
const SELECTOR_PLAYER2_SET3_SCORE = '.player2-set3-score';

// Date Picker
const SELECTOR_VENUE_DATE_TRIGGER_BUTTON = '.js-trigger-venue-date-edit';
const SELECTOR_VENUE_DATE_EDIT_MODAL = '#venue-date-edit-modal';
const SELECTOR_VENUE_DATE_EDIT_MODAL_DIV = '.lta-venue-date-edit';
const SELECTOR_DATE_VALUE_ELEMENT = '.js-venue-date-edit';

// Venue Search
const SELECTOR_VENUE_DETAILS_TRIGGER_BUTTON = '.js-trigger-venue-details-edit';
const SELECTOR_VENUE_DETAILS_EDIT_MODAL = '#venue-details-edit-modal';
const SELECTOR_VENUE_EDIT_MODAL_DIV = '.lta-venue-details-edit';

// Match Details
const SELECTOR_MATCH_EDIT_MODAL_DIV = '.lta-match-details-edit';
const SELECTOR_MATCH_DETAILS_EDIT_MODAL = '#match-details-edit-modal';
const SELECTOR_MATCH_DETAILS_TRIGGER_BUTTON = '.js-trigger-match-details-edit';
const SELECTOR_DEFAULT_SPORT = '.defaultSport';
const SELECTOR_DEFAULT_MATCH_FORM = '.defaultMatchForm';
const SELECTOR_DEFAULT_TENNIS_BALL_COLOR = '.defaultBallColor';
const SELECTOR_DEFAULT_MATCH_CATEGORY = '.defaultCategory'

const EVENT_CLICK = `click`;

class MatchResultPage {
	constructor() {
		this.matchData = {
			'sportType' : document.querySelector('.p-match-result-confirmation__wrapper') && document.querySelector('.p-match-result-confirmation__wrapper').getAttribute('data-sport-type'),
			'tennisType' : document.querySelector('.p-match-result-confirmation__wrapper') && document.querySelector('.p-match-result-confirmation__wrapper').getAttribute('data-match-type'),
			'tennisBallColor' : document.querySelector('.p-match-result-confirmation__wrapper') && document.querySelector('.p-match-result-confirmation__wrapper').getAttribute('data-ball-color'),
			'matchCategory' : document.querySelector('.p-match-result-confirmation__wrapper') && document.querySelector('.p-match-result-confirmation__wrapper').getAttribute('data-match-category')
		}
		this.init();
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);
		if (!this._wrapperElement) {
			return;
		}
		// Match Score
		this._matchScoreEditModalElement = SelectorEngine.findOne(SELECTOR_MATCH_SCORE_EDIT_MODAL, this._wrapperElement);
		this._matchScoreEditButton = SelectorEngine.findOne(SELECTOR_MATCH_SCORE_TRIGGER_BUTTON, this._wrapperElement);
		this._matchScoreEditElement = SelectorEngine.findOne(SELECTOR_MATCH_SCORE_EDIT_MODAL_DIV, this._matchScoreEditModalElement);
		this._matchScoreEditModal = new Modal(this._matchScoreEditModalElement, {});
		this.matchScoreEdit = new MatchScoreEdit(this._matchScoreEditElement);

		this._matchWinnerName = SelectorEngine.findOne(SELECTOR_MATCH_WINNER_NAME, this._wrapperElement);
		this._matchWinnerPartnerName = SelectorEngine.findOne(SELECTOR_MATCH_WINNER_PARTNER_NAME, this._wrapperElement);

		this._matchPlayer1Name = SelectorEngine.findOne(SELECTOR_PLAYER1_NAME, this._wrapperElement);
		this._matchPlayer2Name = SelectorEngine.findOne(SELECTOR_PLAYER2_NAME, this._wrapperElement);
		this._matchPlayer1PartnerName = SelectorEngine.findOne(SELECTOR_PLAYER1_PARTNER_NAME, this._wrapperElement);
		this._matchPlayer2PartnerName = SelectorEngine.findOne(SELECTOR_PLAYER2_PARTNER_NAME, this._wrapperElement);
		this._matchPlayer1Set1Score = SelectorEngine.findOne(SELECTOR_PLAYER1_SET1_SCORE, this._wrapperElement);
		this._matchPlayer1Set2Score = SelectorEngine.findOne(SELECTOR_PLAYER1_SET2_SCORE, this._wrapperElement);
		this._matchPlayer1Set3Score = SelectorEngine.findOne(SELECTOR_PLAYER1_SET3_SCORE, this._wrapperElement);
		this._matchPlayer2Set1Score = SelectorEngine.findOne(SELECTOR_PLAYER2_SET1_SCORE, this._wrapperElement);
		this._matchPlayer2Set2Score = SelectorEngine.findOne(SELECTOR_PLAYER2_SET2_SCORE, this._wrapperElement);
		this._matchPlayer2SetScore = SelectorEngine.findOne(SELECTOR_PLAYER2_SET3_SCORE, this._wrapperElement);

		// Date Picker
		this._venueDateEditModalElement = SelectorEngine.findOne(SELECTOR_VENUE_DATE_EDIT_MODAL, this._wrapperElement);
		this._venueDateButton = SelectorEngine.findOne(SELECTOR_VENUE_DATE_TRIGGER_BUTTON, this._wrapperElement);
		this._venueDateEditElement = SelectorEngine.findOne(SELECTOR_VENUE_DATE_EDIT_MODAL_DIV, this._venueDateEditModalElement);
		this._venueDateEditModal = new Modal(this._venueDateEditModalElement, {});
		this.venueDateEdit = new VenueDateEdit(this._venueDateEditElement);

		// Venue Details
		this._venueDetailsEditModalElement = SelectorEngine.findOne(SELECTOR_VENUE_DETAILS_EDIT_MODAL, this._wrapperElement);
		this._venueDetailsButton = SelectorEngine.findOne(SELECTOR_VENUE_DETAILS_TRIGGER_BUTTON, this._wrapperElement);
		this._venueDetailsEditElement = SelectorEngine.findOne(SELECTOR_VENUE_EDIT_MODAL_DIV, this._venueDetailsEditModalElement);
		this._venueDetailsEditModal = new Modal(this._venueDetailsEditModalElement, {});
		this.venueDetailsEdit = new VenueDetailsEdit(this._venueDetailsEditElement);

		// Match Details
		this._matchDetailsEditModalElement = SelectorEngine.findOne(SELECTOR_MATCH_DETAILS_EDIT_MODAL, this._wrapperElement);
		this._matchDetailsButton = SelectorEngine.findOne(SELECTOR_MATCH_DETAILS_TRIGGER_BUTTON, this._wrapperElement);
		this._defaultSport = SelectorEngine.findOne(SELECTOR_DEFAULT_SPORT, this._wrapperElement);
		this._defaultMatchForm = SelectorEngine.findOne(SELECTOR_DEFAULT_MATCH_FORM, this._wrapperElement);
		this._defaultBallColor = SelectorEngine.findOne(SELECTOR_DEFAULT_TENNIS_BALL_COLOR, this._wrapperElement);
		this._defaultCategory = SelectorEngine.findOne(SELECTOR_DEFAULT_MATCH_CATEGORY, this._wrapperElement);
		this._matchDetailsEditElement = SelectorEngine.findOne(SELECTOR_MATCH_EDIT_MODAL_DIV, this._matchDetailsEditModalElement);
		this._matchDetailsEditModal = new Modal(this._matchDetailsEditModalElement, {});
		this.matchDetailsEdit = new MatchDetailsEdit(this._matchDetailsEditElement);
		
		this.matchDetailsEdit.data = this.matchData;

		this.renderData(this.matchData);
		
		this.matchDetailsEdit.onSave((matchDetails) => {
			this.hideMatchDetailsEditModal();
			this.renderData(matchDetails);
		});

		this.matchDetailsEdit.onCancel(() => {
			this.hideMatchDetailsEditModal();
		});

		EventHandler.on(this._matchDetailsButton, EVENT_CLICK, () => {
			this.showMatchDetailsEditModal();
		});


		// Match Score
		this.renderMatchScoreData(this.matchScoreData);

		this.matchScoreEdit.onSave((matchScoreData) => {
			this.hideMatchScoreEditModal();
			this.renderMatchScoreData(matchScoreData);
		});

		this.matchScoreEdit.onCancel(() => {
			this.hideMatchScoreEditModal();
		});

		EventHandler.on(this._matchScoreEditButton, EVENT_CLICK, () => {
			this.showMatchScoreEditModal();
		});
		

		// Venue Details
		this.renderVenueData(this.venueDetails);

		this.venueDetailsEdit.onSave((venueDetails) => {
			this.hideVenueDetailsEditModal();
			this.renderVenueData(venueDetails);
		});

		this.venueDetailsEdit.onCancel(() => {
			this.hideVenueDetailsEditModal();
		});

		EventHandler.on(this._venueDetailsButton, EVENT_CLICK, () => {
			this.showVenueDetailsEditModal();
		});

		// Venue Date Picker
		this.renderVenueDateData(this.venueDate);

		this.venueDateEdit.onSave((venueDate) => {
			this.hideVenueDateEditModal();
			this.renderVenueDateData(venueDate);
		});

		this.venueDateEdit.onCancel(() => {
			this.hideVenueDateEditModal();
		});

		EventHandler.on(this._venueDateButton, EVENT_CLICK, () => {
			this.showVenueDateEditModal();
		});

	}

	renderData(matchDetails){
		this._defaultSport.innerHTML = matchDetails.sportType;
		this._defaultMatchForm.innerHTML = matchDetails.tennisType;
		this._defaultBallColor.innerHTML = matchDetails.tennisBallColor;
		this._defaultCategory.innerHTML = matchDetails.matchCategory;
	}

	renderVenueData(venueDetails) {
		if(venueDetails && venueDetails.length > 0) {
			const venueContainer = document.querySelector('.js-venue-details-edit div'); 
			venueContainer.innerHTML = '';
			
			const paragraphBold = document.createElement('p');
			paragraphBold.classList.add('u-h6', 'u-text-lta-dark-blue');		
			
			const venueName = document.createTextNode(venueDetails[0].name);
			const venueStreet = document.createTextNode(venueDetails[0].address.street);
			const venueCity = document.createTextNode(venueDetails[0].address.city);
			const venuePostcode = document.createTextNode(venueDetails[0].address.postalcode);
			paragraphBold.append(venueName);
			const venueText = document.createElement('span');
			venueText.classList.add('u-body3', 'u-text-lta-dark-blue');
			venueText.append(paragraphBold);
			venueText.append(venueStreet);
			venueText.append(document.createElement('br'));
			venueText.append(venueCity);
			venueText.append(document.createElement('br'));
			venueText.append(venuePostcode);
			venueContainer.append(paragraphBold);
			venueContainer.append(venueText);
		}
	}

	renderVenueDateData(venueDate){
		if(venueDate) {
			const dateElement = SelectorEngine.findOne(SELECTOR_DATE_VALUE_ELEMENT, this._wrapperElement);
			dateElement.querySelector('.match-date').innerText = venueDate;
		}
	}

	renderMatchScoreData(matchScoreData){
		if(matchScoreData) {
			if(matchScoreData.matchWinner == 'team1') {
				this._matchWinnerName.innerHTML = matchScoreData.player1Name;
				this._matchWinnerPartnerName.innerHTML = matchScoreData.player1PartnerName;
			} else {
				this._matchWinnerName.innerHTML = matchScoreData.player2Name;
				this._matchWinnerPartnerName.innerHTML = matchScoreData.player2PartnerName;
			}
			this._matchPlayer1Set1Score.innerHTML = matchScoreData.set1Player1Score;
			this._matchPlayer1Set2Score.innerHTML = matchScoreData.set2Player1Score;
			this._matchPlayer1Set3Score.innerHTML = matchScoreData.set3Player1Score;
			this._matchPlayer2Set1Score.innerHTML = matchScoreData.set1Player2Score;
			this._matchPlayer2Set2Score.innerHTML = matchScoreData.set2Player2Score;
			this._matchPlayer2SetScore.innerHTML = matchScoreData.set3Player2Score;	
		}
	}

	showMatchDetailsEditModal(){
		this._matchDetailsEditModal.show();
	}

	hideMatchDetailsEditModal(){
		this._matchDetailsEditModal.hide();
	}

	showVenueDetailsEditModal(){
		this._venueDetailsEditModal.show();
	}

	hideVenueDetailsEditModal(){
		this._venueDetailsEditModal.hide();
	}

	showVenueDateEditModal(){
		this._venueDateEditModal.show();
	}

	hideVenueDateEditModal(){
		this._venueDateEditModal.hide();
	}

	showMatchScoreEditModal(){
		this._matchScoreEditModal.show();
	}

	hideMatchScoreEditModal(){
		this._matchScoreEditModal.hide();
	}
}

const globalMatchResultPage = new MatchResultPage();
export default globalMatchResultPage;
